import Geocode, { Attributes } from 'types/Geocode';

export default class MaxMind implements Geocode {
  rawMaxMindData: Geoip2.Result;

  constructor(rawMaxMindData: Geoip2.Result) {
    this.rawMaxMindData = rawMaxMindData;
    if (!this.city || !this.stateAbbreviation || !this.latitude || !this.longitude) {
      throw new Error('(city,state,lat,lon) not found in maxmind response');
    }
  }

  get city(): string {
    return this.rawMaxMindData.city.names.en;
  }

  get stateAbbreviation(): string {
    return this.rawMaxMindData.subdivisions[0].iso_code;
  }

  get latitude(): number {
    return this.rawMaxMindData.location.latitude;
  }

  get longitude(): number {
    return this.rawMaxMindData.location.longitude;
  }

  get zip(): string {
    return this.rawMaxMindData.postal.code;
  }

  toJSON(): Attributes {
    return {
      city: this.city,
      latitude: this.latitude,
      longitude: this.longitude,
      stateAbbreviation: this.stateAbbreviation,
      zip: this.zip,
    };
  }
}
